import { BodyMD, BodyXL, Heading2XL, Heading3XL } from "../../../typography";

import { CoverageSectionProps } from "../../new_home/types";
import { Fragment } from "react";
import { RiveAnimation } from "../../components/ui/RiveAnimation";

export const CoverageSection = ({
  title,
  descriptions,
}: CoverageSectionProps) => (
  <div
    className="tw-flex tw-w-full tw-flex-col"
    style={{
      background:
        "linear-gradient(180deg, #FFF 0%, #FFF 0.75%, #FFF 2.92%, #FDFEFF 6.37%, #FBFDFF 10.97%, #F7FCFF 16.59%, #F2FAFF 23.1%, #EAF7FF 30.37%, #E0F3FF 38.27%, #D3EDFF 46.66%, #C3E7FF 55.41%, #AFDFFF 64.39%, #97D5FF 73.47%, #7ACAFF 82.52%, #59BCFF 91.41%, #33ADFF 100%)",
    }}
  >
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-y-[16px] tw-px-[1.3em]">
      <Heading3XL className="tw-my-0 tw-hidden tw-max-w-[678px] tw-text-center tw-text-blue-dark-3 min440:tw-flex">
        {title}
      </Heading3XL>
      <Heading2XL className="tw-my-0 tw-max-w-[678px] tw-text-center tw-text-blue-dark-3 min440:tw-hidden">
        {title}
      </Heading2XL>
      {descriptions.map((description) => (
        <Fragment key={description}>
          <BodyXL className="tw-my-0 tw-hidden tw-max-w-[678px] tw-text-center tw-text-gray-2 min440:tw-flex">
            {description}
          </BodyXL>
          <BodyMD className="tw-my-0 tw-max-w-[678px] tw-text-center tw-text-gray-2 min440:tw-hidden">
            {description}
          </BodyMD>
        </Fragment>
      ))}
      <div className="tw-aspect-[2/1] tw-w-full tw-max-w-[864px]">
        <RiveAnimation
          src="/landing_page_assets/rive/09.riv"
          className="tw-h-full tw-w-full tw-object-cover"
        />
      </div>
    </div>
  </div>
);
